/** Datum und Zeit immer in deutscher Schreibweise und Ortszeit Europe/Berlin. */
const dateTime = new Intl.DateTimeFormat('de-DE', {
  timeZone: 'Europe/Berlin',
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});
const dateOnly = new Intl.DateTimeFormat('de-DE', { timeZone: 'Europe/Berlin', day: '2-digit', month: '2-digit', year: 'numeric' });
const timeOnly = new Intl.DateTimeFormat('de-DE', { timeZone: 'Europe/Berlin', hour: '2-digit', minute: '2-digit' });

export function fmtDateTime(iso: string | null | undefined): string {
  return iso ? dateTime.format(new Date(iso)) : '-';
}

export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return '-';
  return dateOnly.format(new Date(iso.length === 10 ? `${iso}T12:00:00Z` : iso));
}

export function fmtTime(iso: string | null | undefined): string {
  return iso ? timeOnly.format(new Date(iso)) : '-';
}

/** „vor 12 min“, „vor 3 h“, „vor 2 Tagen“ – für Warteschlange und Maschinenseite. */
export function fmtAge(iso: string | null | undefined, now = Date.now()): string {
  if (!iso) return '-';
  const minutes = Math.max(0, Math.round((now - new Date(iso).getTime()) / 60_000));
  if (minutes < 1) return 'gerade eben';
  if (minutes < 60) return `vor ${minutes} min`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `vor ${hours} h`;
  const days = Math.round(hours / 24);
  return days === 1 ? 'vor 1 Tag' : `vor ${days} Tagen`;
}

export function fmtMinutes(min: number | null | undefined): string {
  if (min === null || min === undefined) return '-';
  if (min < 60) return `${min} min`;
  const h = min / 60;
  if (h < 48) return `${Math.round(h * 10) / 10} h`;
  return `${Math.round((h / 24) * 10) / 10} Tage`;
}

/** Für `<input type="datetime-local">` in Ortszeit. */
export function toLocalInput(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function fromLocalInput(value: string): string | null {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
}
